import React, { Fragment } from "react";

const TourGuidePackageTable = ({
  setPackageSelect,
  setViewPage,
  marchantTourCreateDatas,
  handleEdit,
  setUpdateSubmitButtonCondition,
  setMarchantCreateDatas,
}) => {
  const goToNextStep = () => {
    setPackageSelect(null);
  };
  const goToAnotherOption = () => {
    setPackageSelect(4);
    setViewPage(null);
    setUpdateSubmitButtonCondition(false);
  };

  return (
    <div>
      <h2 className="text-[22px] text-center text-btn-secondary">
        Guide View Selected
      </h2>

      <div>
        <div className="my-[32px]">
          {marchantTourCreateDatas?.tour_package_guide_options?.length === 0 ? (
            <div className="my-[40px]">
              <p className="text-center">No Data Found!</p>
            </div>
          ) : (
            <div>
              {marchantTourCreateDatas?.tour_package_guide_options?.map(
                (tourOption, index) => (
                  <Fragment key={index}>
                    <div className="mb-[16px]"></div>
                    <table className="fl-table mb-[40px]">
                      <thead className="sticky top-[88px]">
                        <tr>
                          <th>
                            <span>SL. No.</span>
                          </th>
                          <th>Guide for day</th>

                          <th>Uinit Price</th>
                          <th>Provided Day</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tourOption?.tour_package_guide_packages?.map(
                          (transferPackage, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>
                                {transferPackage.number_of_guides_for_day}
                              </td>
                              <td>
                                {transferPackage.tour_guide_price_per_day}
                              </td>
                              <td>
                                <div className="flex gap-x-[6px] ">
                                  <p
                                    key={index}
                                    className="bg-btn-secondary py-[4px] px-[6px] rounded-[4px] text-bg-white"
                                  >
                                    {transferPackage?.day_number?.label}
                                  </p>
                                </div>
                              </td>

                              <td>
                                <div className="flex items-center justify-center">
                                  <div>
                                    <span
                                      onClick={() => {
                                        handleEdit(
                                          tourOption?.tour_package_guide_packages,
                                          index
                                        );
                                      }}
                                      className="text-[#239B56] "
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="w-[30px] h-[30px] cursor-pointer"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
                                        />
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </Fragment>
                )
              )}
            </div>
          )}

          <div className="flex justify-end mt-[30px]">
            <div className="flex flex-row gap-x-[30px]">
              <button
                className="bg-btn-secondary text-bg-white py-[4px] px-[30px] rounded-[4px]"
                onClick={() => goToAnotherOption()}
              >
                Add Another
              </button>
              <button
                className="bg-btn-secondary text-bg-primary py-[4px] px-[30px] rounded-[4px]"
                onClick={() => goToNextStep()}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourGuidePackageTable;
